import { Select, TextBox } from '@veneer/core';
import './../../assets/css/views/subRetailManagement/subRetailManagement.css';
import { useEffect } from 'react';
import SubRetailManagementLogic from './SubRetailManagementLogic';
import { FormFieldsSubRetail } from '../../models/input/agendaApi/ISubRetail';
import LoaderModal from '../../components/Loader/loaderModal';
import { useTranslation } from 'react-i18next';

const UpdateSubretailScreen = ({ setFormPointOfSaleUpdate, formPointOfSaleUpdate }: any) => {
    const [t] = useTranslation("global");
    const { getCountriesList, getRetailList, getTierList, getFormatList,
        setDataCountries, setDataFormatPos, setDataRetailList, setDataTier, handleChangeSearch,
        dataTier, dataCountries, dataRetailList, dataFormatPos, loading, currentDataSelect } = SubRetailManagementLogic()

    useEffect(() => {
        getCountriesList()
        getRetailList()
        getTierList()
        getFormatList()
    }, [])

    const onChangeForm = (option: { value: number | string; label?: string }, type: keyof FormFieldsSubRetail) => {

        setFormPointOfSaleUpdate((prev: FormFieldsSubRetail) => {
            const isEmptyValue = option.value === '';
            const updatedForm = {
                ...prev,
                [type]: isEmptyValue ? [] : [option.value],
                ...(type === 'retailId' && { nameRetail: [option.label] })
            };
            return updatedForm;
        });
    };

    const clearfieldFromForm = (field: keyof FormFieldsSubRetail) => {
        setFormPointOfSaleUpdate((prev: FormFieldsSubRetail) => {
            const newState: Partial<FormFieldsSubRetail> = { [field]: [] };
            return { ...prev, ...newState };
        });
    };

    return (
        <div >
            <form style={{ width: '100%' }}>
                <div className="form-subRetailManagement" key={'country'} style={{ flex: 12 }}>
                    <div style={{ flex: 4, height: '50px', textAlign: 'center' }}>
                        <label htmlFor="country">{t('header.country')}</label>
                    </div>
                    <div style={{ flex: 8, textAlign: 'left' }}>
                        <Select
                            options={dataCountries}
                            id="select-usage"
                            label={t('header.country')}
                            placement="bottom"
                            helperTextVisibility="auto"
                            onChange={(value) => onChangeForm(value, 'countryId')}
                            onClear={() => clearfieldFromForm('countryId')}
                            value={[Number(formPointOfSaleUpdate.countryId)]}
                            disabled={false}
                            showSearch
                            onSearch={(value) => handleChangeSearch(value, currentDataSelect.dataCountryList, setDataCountries)}
                        />
                    </div>
                </div>
                <div className="form-subRetailManagement" key={'retail'} style={{ flex: 12 }}>
                    <div style={{ flex: 4, height: '50px', textAlign: 'center' }}>
                        <label htmlFor="country">{t('posManagement.retail')}</label>
                    </div>
                    <div style={{ flex: 8, textAlign: 'left' }}>
                        <Select
                            options={dataRetailList}
                            id="select-usage"
                            label={t('posManagement.retail')}
                            placement="bottom"
                            helperTextVisibility="auto"
                            onChange={(value) => onChangeForm(value, 'retailId')}
                            onClear={() => clearfieldFromForm('retailId')}
                            value={[Number(formPointOfSaleUpdate.retailId)]}
                            disabled={false}
                            showSearch
                            onSearch={(value) => handleChangeSearch(value, currentDataSelect.dataRetailList, setDataRetailList)}
                        />
                    </div>
                </div>
                <div className="form-subRetailManagement" key={'company'} style={{ flex: 12 }}>
                    <div style={{ flex: 4, height: '50px', textAlign: 'center' }}>
                        <label htmlFor="company">{t('posManagement.company')}</label></div>
                    <div style={{ flex: 8, textAlign: 'left' }}>
                        <TextBox
                            id='longitude'
                            className="textBoxContainer"
                            type="text"
                            maxLength={100}
                            value={formPointOfSaleUpdate.companyId[0] ?? ''}
                            onChange={(value) => onChangeForm({ value: value }, 'companyId')}
                        />
                    </div>
                </div>
                <div className="form-subRetailManagement" key={'Subretail'} style={{ flex: 12 }}>
                    <div style={{ flex: 4, height: '50px', textAlign: 'center' }}>
                        <label htmlFor="Subretail">{t('posManagement.subRetail')}</label>
                    </div>
                    <div style={{ flex: 8, textAlign: 'left' }}>
                        <TextBox
                            id='longitude'
                            className="textBoxContainer"
                            type="text"
                            maxLength={100}
                            value={formPointOfSaleUpdate.subRetailId[0] ?? ''}
                            onChange={(value) => onChangeForm({ value: value }, 'subRetailId')}
                        />
                    </div>
                </div>
                <div className="form-subRetailManagement" key={'Tier'} style={{ flex: 12 }}>
                    <div style={{ flex: 4, height: '50px', textAlign: 'center' }}>
                        <label htmlFor="Tier">{t('posManagement.tier')}</label>
                    </div>
                    <div style={{ flex: 8, textAlign: 'left' }}> <Select
                        options={dataTier}
                        id="select-usage"
                        label={t('posManagement.tier')}
                        placement="bottom"
                        helperTextVisibility="auto"
                        onChange={(value) => onChangeForm(value, 'tierId')}
                        onClear={() => clearfieldFromForm('tierId')}
                        value={[Number(formPointOfSaleUpdate.tierId)]}
                        disabled={false}
                        showSearch
                        onSearch={(value) => handleChangeSearch(value, currentDataSelect.dataTierList, setDataTier)}
                    />
                    </div>
                </div>
                <div className="form-subRetailManagement" key={'formatPOS'} style={{ flex: 12 }}>
                    <div style={{ flex: 4, height: '50px', textAlign: 'left' }}>
                        <label htmlFor="formatPOS">{t('subRetailManagement.formatPos')}</label>
                    </div>
                    <div style={{ flex: 8, textAlign: 'left' }}> <Select
                        options={dataFormatPos}
                        id="select-usage"
                        label={t('subRetailManagement.formatPos')}
                        placement="bottom"
                        helperTextVisibility="auto"
                        onChange={(value) => onChangeForm(value, 'formatPosID')}
                        onClear={() => clearfieldFromForm('formatPosID')}
                        value={[Number(formPointOfSaleUpdate.formatPosID)]}
                        disabled={false}
                        showSearch
                        onSearch={(value) => handleChangeSearch(value, currentDataSelect.dataSubRetailFormat, setDataFormatPos)}
                    />
                    </div>
                </div>
            </form>
            {loading &&
                <div>
                    <LoaderModal >
                        <div> {t('modal.savingInformation')}</div>
                    </LoaderModal>
                </div>
            }
        </div>
    );
};

export default UpdateSubretailScreen;
